"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
class OpenFileButton extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            this.input.click();
        };
        this.fileChanged = (evt) => {
            const file = this.input.files[0];
            if (!file) {
                console.error("no file");
                return;
            }
            const fr = new FileReader();
            fr.onload = e => {
                if (e && e.target) {
                    const content = e.target.result;
                    if (content) {
                        this.props.onOpen(content);
                    }
                    else {
                        console.error("Unable to read content");
                    }
                }
                else {
                    console.error("No event/target supplied for onload callback to readAsText");
                }
            };
            fr.readAsText(file);
        };
    }
    render() {
        return (React.createElement("a", { onClick: this.onClick, className: "little-button" },
            this.props.label,
            React.createElement("input", { type: "file", id: "file", accept: ".json", ref: comp => (this.input = comp), style: { display: "none" }, onChange: this.fileChanged })));
    }
}
exports.default = OpenFileButton;



// WEBPACK FOOTER //
// ./src/components/editor/OpenFileButton.tsx